import React, { PropsWithChildren } from 'react';

import classes from './QtyInput.scss';

export function QtyInput(props: PropsWithChildren<{ id: string }>) {
    return (
        <div className={classes.root}>
            <label className={classes.label} htmlFor={props.id}>
                Qty
            </label>
            <div className={classes.input}>{props.children}</div>
        </div>
    );
}
